import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createThunkErrorHandler } from '../../utils/handleThunkError.js';
import { handlePending } from '../../utils/handlePending.js';
import { getAll } from '../../http/orderAPI.js';
import { getResultSearch } from '../../http/searchAPI.js';
export const getOrders = createAsyncThunk(
    'orders/getOrders',
    async function (params = {}, { rejectWithValue, dispatch, getState }) {

        dispatch(clearErrors())
        const state = getState().orders;
        const page = params.page ?? state.page;
        const limit = params.limit ?? state.limit;

        try {
            const data = await getAll(page, limit)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Failed')
        }

    }
)

export const getLastOrders = createAsyncThunk(
    'orders/getLastOrders',
    async function (params = {}, { rejectWithValue, dispatch, getState }) {

        dispatch(clearErrors())
        const state = getState().orders;
        const page = params.lastOrderPage ?? state.lastOrderPage;
        const limit = params.lastOrderLimit ?? state.lastOrderLimit;



        try {
            const data = await getAll(page, limit)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Failed')
        }

    }
)

export const searchOrders = createAsyncThunk(
    'orders/searchOrders',
    async function (query) {
        try {
            const data = await getResultSearch(query, 'order_user')
            return data
        } catch (e) {
            throw new Error(e.response.data.message)
        }
    }
)

const ordersSlice = createSlice({
    name: 'orders',
    initialState: {
        errors: {},
        globalError: null,
        isLoading: false,
        data: [],
        count: 0,
        limit: 30,
        page: 1,
        lastOrder: [],
        lastOrderLimit: 9,
        lastOrderPage: 1,
    },
    reducers: {


        clearErrors: (state) => {
            state.errors = {}
            state.globalError = null
        },

        clearGlobalError: (state) => {
            state.globalError = null
        },

        setPageOrders(state, action) {
            const { page } = action.payload;
            state.page = page;
        },



    },

    extraReducers: builder => {
        builder
            .addCase(getOrders.rejected, createThunkErrorHandler("ORDERS"))
            .addCase(getOrders.pending, handlePending)
            .addCase(getOrders.fulfilled, (state, action) => {
                state.isLoading = false
                state.data = action.payload.data
                state.count = action.payload.count
                state.errors = {}
            })

            .addCase(getLastOrders.rejected, createThunkErrorHandler("LAST_ORDERS"))
            .addCase(getLastOrders.pending, handlePending)
            .addCase(getLastOrders.fulfilled, (state, action) => {
                state.isLoading = false
                state.lastOrder = action.payload.data
                state.errors = {}
            })

            .addCase(searchOrders.rejected, createThunkErrorHandler("SEARCH_ORDERS"))
            .addCase(searchOrders.pending, handlePending)
            .addCase(searchOrders.fulfilled, (state, action) => {
                state.isLoading = false
                state.data = action.payload.data
            })






    }
});

export const {
    clearErrors,
    clearGlobalError,
    setPageOrders
} = ordersSlice.actions;

export default ordersSlice.reducer;